export default class Group {
  constructor(payload) {
    this.id = payload.id;
    this.name = payload.name;
    this.organizationId = payload.organizationId;
    this.screens = payload?.screens ?? [];
    this.schedules = payload?.schedules ?? [];
    this.screensCount = payload?.screensCount
      ? payload?.screensCount
      : payload?.screens
      ? payload?.screens?.length
      : null;
    this.schedulesCount = payload?.schedulesCount
      ? payload?.schedulesCount
      : payload?.schedules
      ? payload?.schedules?.length
      : null;
  }
}
